exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2lGBI{position:absolute;z-index:50;top:0;right:0;bottom:0;left:0;display:flex;flex-direction:column;background-color:#000;justify-content:center;align-items:center}._2lGBI,._2lGBI.tuJDT video,._2lGBI._3NRnm video{width:100%;height:100%}._2lGBI._2kM3H.CcmF7 video{width:100%}._2lGBI._3yap8.CcmF7 video{height:100%}._2lGBI video{position:relative;z-index:1;box-shadow:0 0 20px rgba(0,0,0,.2)}._2lGBI.ND-Dd{cursor:none}._2jFRc{position:absolute;z-index:0;top:0;right:0;bottom:0;left:0;filter:blur(14px)}", ""]);

// exports
exports.locals = {
	"screen": "_2lGBI",
	"blurMode": "tuJDT",
	"regularMode": "_3NRnm",
	"verticalStripes": "_2kM3H",
	"fillMode": "CcmF7",
	"horizontalStripes": "_3yap8",
	"hiddenCursor": "ND-Dd",
	"backgroundCanvas": "_2jFRc"
};